// Module
var code = "<template> <require from=\"app/cm/components/assessments/assessment-attachments\"></require> <assessment-attachments target-id.bind=\"caseId\" config.bind=\"assessmentsConfig\" readonly.bind=\"readonly\" view-model.ref=\"$attachments\" show-iccc.bind=\"true\"> </assessment-attachments> </template> ";
// Exports
module.exports = code;